import { useCallback } from "react";
import { useMutation } from "@apollo/client";
import throttle from "lodash/throttle";

/**
 * Does the same thing as `@apollo/client.useMutation` except it applies a 1 second throttle
 * to prevent rapid submission. Unfortunately, the `loading` flag is not quick enough if the
 * user burst presses the button that executes the mutation.
 */
const useThrottledMutation: typeof useMutation = (mutation, options) => {
  const [mutate, mutationStatus] = useMutation(mutation, options);

  // we are not exposing that
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const throttledMutate: typeof mutate = useCallback(
    throttle(mutate, 1000, {
      leading: true,
      trailing: false,
    }),
    [mutate],
  );

  return [throttledMutate, mutationStatus];
};

export default useThrottledMutation;
